import { getItemMaker } from "./tools";

const i = getItemMaker("rings");
export const rings = [
  i("Copper Band", "EquipmentRings2"),
  i("Pugilist Demise", "EquipmentRings7"),
  i("Steel Band", "EquipmentRings3"),
  i("Elf Twist Ring", "EquipmentRings21"),
  i("Silver Stopwatch", "EquipmentRings13"),
  i("Dooble Goopi", "EquipmentRings14"),
  i("Rex Ring", "EquipmentRings20"),
  i("Defenders Dignity", "EquipmentRings11"),
  i("Frisbee Ring", "EquipmentRings12"),
  i("Serrated Rex Ring", "EquipmentRings26"),
  i("Death Wish", "EquipmentRings6"),
  i("Sanic Ring"),
  i("Bejeweled Ring"),
  i("Protectors Pride"),
  i("Efaunt Trunculus"),
  i("Dawn Stopwatch"),
  i("Midnight Stopwatch"),
  i("Neutron Ice Ring", "EquipmentRings23"),
  i("Lab Ring", "EquipmentRings24"),
  i("Chef Ring", "EquipmentRings25"),
  i("Souped Lab Ring", "EquipmentRings30"),
  i("Tenacity Ring"),
  i("Zero Point Stopwatch"),
  i("Demented Emperor Opal"),
  i("Dune Killer Ring"),
  i("Tundra Killer Ring"),
  i("Nebula Killer Ring"),
  i("Magma Killer Ring"),
  i("Shallow Watering", "EquipmentRingsFishing1"),
  i("Oceanic Ring", "EquipmentRingsFishing2"),
  i("Deepwater Trench Ring"),
];
